<template>
  <div>
    <b-modal
      centered
      scrollable
      v-model="showModalInput"
      :hide-footer="true"
      @close="onClose"
      @hidden="onClose"
      @keydown.esc="onClose"
      no-close-on-backdrop
      id="Modal"
      :static="true"
    >
      <template #modal-header>
        <div class="header">
          <div class="title">
            <h4 class="mb-0">{{ $t("Import Domains") }}</h4>
          </div>
          <div class="actions">
            <button class="close" @click="onClose()">&times;</button>
          </div>
        </div>
      </template>
      <div class="upload-body">
        <div>
          <svg
            v-if="!uploadedFiles.fileUpload.files"
            xmlns="http://www.w3.org/2000/svg"
            fill="#8b94a0"
            class="bi bi-arrow-up-circle isActive"
            viewBox="0 0 16 16"
          >
            <path
              d="M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0zm-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z"
            />
          </svg>

          <svg
            v-if="uploadedFiles.fileUpload.files"
            fill="#3f88ff"
            xmlns="http://www.w3.org/2000/svg"
            class="bi bi-check-square isActive"
            viewBox="0 0 16 16"
          >
            <path
              d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
            />
            <path
              d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.235.235 0 0 1 .02-.022z"
            />
          </svg>
        </div>
        <p class="modal-content">
          {{
            $t("Import the list of domains in csv format. One domain per line")
          }}
        </p>
        <transition name="fade" mode="out-in">
          <div v-if="uploadedFiles.fileUpload.name" class="mt-3 isActive">
            <p>
              {{ $t("Uploaded file") }}: {{ uploadedFiles.fileUpload.name }}
            </p>
          </div>
        </transition>
        <b-spinner
          class="my-5"
          variant="primary"
          :label="this.$t('Spinning')"
          v-if="updatedSpinner"
        ></b-spinner>
        <b-dropdown
          v-if="!updatedSpinner"
          id="dropdown-aria"
          :text="this.$t('Import File')"
          class="m-2 btn-secondary dropdown"
        >
          <b-dropdown-item-button value="allow" @click="onPickFile($event)">
            {{ $t("Allowed Domains") }}

            <input
              type="file"
              style="display: none"
              ref="fileInput"
              class="input"
              accept=".csv"
              @change="onFilePicked"
            />
          </b-dropdown-item-button>

          <b-dropdown-item-button value="block" @click="onPickFile($event)">
            {{ $t("Blocked Domains") }}
            <input
              type="file"
              name="input2"
              class="input"
              style="display: none"
              ref="fileInput"
              accept=".csv"
              @change="onFilePicked"
            />
          </b-dropdown-item-button>
        </b-dropdown>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "TUploader",
  props: ["dialog"],

  data() {
    return {
      fileUpload: {},
    };
  },
  computed: {
    ...mapGetters("fileUpload", ["uploadedFiles", "updatedSpinner"]),
    showModalInput: {
      get() {
        return this.dialog;
      },
      set() {},
    },
  },
  methods: {
    ...mapActions("fileUpload", ["uploaderFile", "clearCache", "setSpinenr"]),

    onClose() {
      this.showModalInput = false;
      this.clearCache();
    },
    onPickFile(e) {
      if (e.target.value) {
        this.fileUpload.domain = e.target.value;
        this.$refs.fileInput.value = "";

        this.$refs.fileInput.click();
      }
    },

    onFilePicked(event) {
      this.setSpinenr(true);
      this.fileUpload.name = event.target.files[0].name;
      this.fileUpload.files = event.target.files[0];
      this.uploaderFile(this.fileUpload);
      setTimeout(() => {
        this.$emit("submitFiles", this.fileUpload);
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-body {
  height: 317px;
}
::v-deep .modal {
  header {
    padding: 20px 2rem;
    border-bottom: none;
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;

      .actions {
        display: flex;
        align-items: center;
        button {
          background: none;
          border: none;
          padding: 0;
          font-size: 2rem;
        }
      }
    }
  }
}
::v-deep .dropdown {
  width: 200px;
  margin: 20px auto;
  .dropdown-menu {
    transform: translate3d(5px, 35px, 0px) !important;
  }
}
.modal-header {
  padding: 16px 16px;
  border-bottom: 0px dashed #ffff;
}
.modal-content {
  width: 215px;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  border: none;
}
::v-deep .spinner-border {
  position: relative;
  left: 40%;
}
::v-deep .modal-body {
  display: flex !important;
  justify-content: center !important;
  text-align: center !important;
}
.upload-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  p {
    margin-bottom: 0;
    font-size: 14px;
    color: #8b94a0;
  }
  svg {
    width: 50px;
    height: 50px;
    margin-bottom: 25px;
    color: #8b94a0;
  }
  .isActive {
    transition: 0.5s;
    // background-color: #3f88ff;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
